import {
    renderAccount,
    renderAircraft,
    renderCloudAhoy,
    renderBilling,
    renderCustomContent,
    renderDataDownloads,
    renderDirectory,
    renderDispatch,
    renderEnterpriseDocuments,
    renderDocs,
    renderFleetTracking,
    renderFlights,
    renderFSP,
    renderHoneywellForge,
    renderImagery,
    renderMarketplace,
    renderJetFuelX,
    renderLogbook,
    renderInsurance,
    renderMap,
    renderOrg,
    renderPeople,
    renderReservoir,
    renderRoster,
    renderTrackLogs,
    renderOrgSettings,
    renderSmartGroups,
    renderDefaultRecap,
    renderChecklist,
    renderFlightScheduler,
    renderAirportDirectory,
    renderFleet,
    renderSafetyManagementSystems,
    renderJra,
    renderJourneyLog,
    renderLogbookCTA,
    renderTripPlanner,
} from 'ff/common/components/FFMenuV2/MenuItems';
import renderDivider from 'ff/common/components/FFMenuV2/MenuItems/Divider';
import fillSpace from 'ff/common/components/FFMenuV2/MenuItems/FillSpace';
import { RenderMenuParams } from 'ff/common/components/FFMenuV2/RenderMenuParams';
import { hasTrackingLicense, hasTrackingRole } from 'ff/common/system';

export default function RenderDefaultMenu(params: RenderMenuParams) {
    return [
        renderDefaultRecap,
        // show Trip Planner in the sidebar only when the Trip Planner feature is enabled for the current user
        params?.featureFlags?.trip_planner && params?.currentUser?.trip_planner
            ? renderTripPlanner
            : null,
        params?.currentUser?.dispatch_tools ||
        params?.currentUser?.isFF_FspAdmin
            ? renderDispatch
            : null,
        params?.currentUser?.jeppesen_runway_analysis ? renderJra : null,
        // show Tracking if the org has a Tracking license AND the user has Tracking access
        // OR if the org does not have Tracking but does have Dispatch -- will redirect to ad to purchase Tracking
        params?.currentUser &&
        ((hasTrackingLicense(params?.currentUser) &&
            hasTrackingRole(params?.currentUser)) ||
            (!hasTrackingLicense(params?.currentUser) &&
                params?.currentUser?.dispatch_tools &&
                !params?.currentUser?.hasDispatchLowca))
            ? renderFleetTracking
            : null,
        renderFlights,
        renderMap,
        renderImagery,
        params?.featureFlags?.show_marketplace ? renderMarketplace : null,
        renderDocs,
        renderJourneyLog,
        renderCustomContent,
        renderAircraft,
        renderFleet,
        renderSafetyManagementSystems,
        renderFlightScheduler,
        renderAirportDirectory,
        renderLogbook,
        renderChecklist,
        renderInsurance,
        renderTrackLogs,
        renderCloudAhoy,
        renderPeople,
        renderReservoir,
        renderDirectory,
        renderHoneywellForge,
        renderRoster,
        renderDataDownloads,
        renderDivider,
        renderFSP,
        renderOrg,
        renderOrgSettings,
        renderSmartGroups,
        renderBilling,
        renderEnterpriseDocuments,
        renderJetFuelX,
        renderDivider,
        renderAccount,
        renderLogbookCTA,
        fillSpace.bind(null, { flex: '1' }),
    ];
}
